import React from 'react';
import {Chip, ChipProps} from '@mui/material';
import {useListContext} from './ListContext';

interface TotalChipProps extends Omit<ChipProps, 'label'> {
  label: string;
}

const TotalChip: React.FC<TotalChipProps> = ({label, ...chipProps}) => {
  const {total} = useListContext();
  return <Chip label={`${total} ${label}`} color="primary" variant="outlined" size="small" sx={{fontWeight: 500}} {...chipProps} />;
};

export default TotalChip;
